import React from "react";
import { CustomButton } from "../presentation/components/customButton/CustomButton";
import {
  PRIMARY_COLOR,
  WHITE_COLOR,
} from "../presentation/resources/colorsManager";

function RowButtons({
  onClick2,
  onClick1,
  style,
  buttonTitle1 = "Cancel",
  buttonTitle2 = "Verify",
  buttonStyle2,
  buttonStyle1,
  disabled2,
  textStyles1,
  textStyles2,
  loading2,
}) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        ...style,
      }}
    >
      <CustomButton
        title={buttonTitle1}
        backgroundColor={WHITE_COLOR}
        textStyles={{
          color: PRIMARY_COLOR,
          ...textStyles1,
        }}
        styles={{
          border: `1px solid ${PRIMARY_COLOR}`,
          width: "40%",
          minWidth: 170,
          ...buttonStyle1,
        }}
        onClick={onClick1}
      />
      <CustomButton
        title={buttonTitle2}
        backgroundColor={PRIMARY_COLOR}
        onClick={onClick2}
        styles={{
          width: "40%",
          minWidth: 170,
          ...buttonStyle2,
        }}
        disabled={disabled2}
        textStyles={{
          ...textStyles2,
        }}
        loading={loading2}
      />
    </div>
  );
}

export default RowButtons;
